import { TDocType } from 'components/Registration/IntroducerOnboarding/RegistrationForm/registrationForm.types';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useGetIntroducerDocuments } from 'lendingApi/lendingApiHooks';
import * as yup from 'yup';

export const useRegistrationDocuments = () => {
  const { introducerId, isContextLoading, introducerCompany } =
    useIntroducerContext();
  const { data: introducerDocuments, isLoading: isLoadingIntroducerDocuments } =
    useGetIntroducerDocuments(introducerId);

  const REQUIRED_DOC_TYPES: TDocType[] = [
    'bank_statement',
    'certified_id',
    'proof_of_address',
  ];

  const uploadedDocTypes =
    introducerDocuments?.data.map((doc) => doc.document_type) ?? [];

  const missingDocTypes = REQUIRED_DOC_TYPES.filter(
    (required) => !uploadedDocTypes.includes(required),
  );

  const schema = yup.object().shape({
    certifiedIdFile: missingDocTypes.includes('certified_id')
      ? yup.mixed().required('Certified ID is required')
      : yup.mixed().nullable(),
    bankStatementFile: missingDocTypes.includes('bank_statement')
      ? yup.mixed().required('Bank statement is required')
      : yup.mixed().nullable(),
    proofOfAddressFile: missingDocTypes.includes('proof_of_address')
      ? yup.mixed().required('Proof of business address is required')
      : yup.mixed().nullable(),
  });

  return {
    schema,
    introducerId,
    introducerAccountId: introducerCompany?.id,
    isLoading: isContextLoading || isLoadingIntroducerDocuments,
    missingDocTypes,
  };
};
